import React, {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import classnames from 'classnames';
import {useGlobalContext} from '../../core/GlobalContext';
import ButtonAction from '../ButtonAction';
import ModalPopup from '../ModalPopup';
import styles from './PopupRedirectToForm101.module.scss';
import doc from '../../../assets/icons/document-text-outline.svg';

type PopupRedirectToForm101Props = {
  type: 'button' | 'link'
  link: string
  redirectLink: string
}

const PopupRedirectToForm101 = ({type = 'link', link, redirectLink}: PopupRedirectToForm101Props) => {
  const {layoutDirection} = useGlobalContext();
  const location = useLocation();
  const sameLocation = location.pathname === link;
  const [show, setShow] = useState(false);
  const prefix = 'orderInvoice-modal-redirect-to-101';
  return (
    <>
      {type === 'link'
        ? (
          <div className={classnames(
            styles.navItemContainer,
            {[styles.activeLink]: sameLocation},
          )}>
            <div
              onClick={() => setShow(true)}
              className={styles.navItem}
              data-testid="handle-open-popup-redirect"
            >
              <FormattedMessage id={'link-orderInvoice'} defaultMessage={'Order Invoice'}/>
            </div>
          </div>
        )
          : (
          <div
            className={classnames(styles.menuItem, styles.linkContainer)}
            onClick={() => setShow(true)}
            data-testid="handle-open-popup-redirect"
          >
            <div className={styles.orderInvoice}>
              <img src={doc} alt="doc" className={styles.orderInvoiceIcon}/>
              <div className={styles.orderInvoiceText}>
                <FormattedMessage
                  id={'dashboard-link-orderInvoice'}
                  defaultMessage={'Order Invoice'}
                />
              </div>
            </div>
          </div>
        )
      }
      <ModalPopup
        isOpen={show}
        onRequestClose={() => setShow(false)}
      >
        <div dir={layoutDirection} className={styles.popupInnerWrapper}>
          <div className={styles.title}>
            <FormattedMessage
              id={`${prefix}-message`}
              defaultMessage={'To order an invoice, you must first fill out Form 101 for the current year.'}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <ButtonAction
              variant={'reject'}
              onClick={() => setShow(false)}
              label={<FormattedMessage id={`${prefix}-label-cancel`} defaultMessage={'Cancel'}/>}
              customClassnames={{container: styles.mobileCancel}}
            />
            <a
              href={redirectLink}
              target={'_self'}
              className={styles.linkButton}
            >
              <FormattedMessage id={`${prefix}-label-redirect`} defaultMessage={'Filling out form 101'}/>
            </a>
          </div>
        </div>
      </ModalPopup>
    </>
  );
};
export default PopupRedirectToForm101;
